import template from 'text!./additionalCoverages.html';
import controller from './additionalCoveragesCtrl';

/**
 * @ngdoc component
 * @name gw-bop-additional-coverages
 *
 * @description  A bop component to display the additional coverages step into a wizard flow
 *
 */
export default {
    controller: controller,
    template: template,
    bindings: {
        updateCoverages: '='
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/coverages/additional/index.js
// module id = 810
// module chunks = 0